# TODO: brittany 10/4 - This is stale.  Spoke w/David - premium job sources are no longer a thing.
$(->
  if $('body').slider?
    configure_slider = ->
      if $('#premium_job_source_amount').length > 0
        $('#premium_job_source_amount').slider(
          value: 150,
          min: 100,
          max: 350,
          step: 50
        ).on('slideStop', ( event )->
          val = $('#premium_job_source_amount').slider('getValue')
          $( "#slider_amount" ).html( "$" + val )
        )

    $(document).on 'show.bs.modal', '.modal', ->
      configure_slider()

    configure_slider()
)
